export const manualInvoiceImporting = {
	form: {
		num: "Número de la factura",
		serie: "Serie de la factura",
		date: "Fecha de emisión",
		inputDate: "Fecha de entrada en el inventario físico",
		operationType: "Naturaleza de la operación",
		accessKey: "Clave de acceso",
		supplier: "Emisor",
		suppliers: "Proveedores",
		newSupplier: "Nuevo proveedor",
		totalValue: "Valor de la factura",
		discountValue: "Descuentos",
		finalValue: "Valor total",
		amountOfDuplicates: "Número de cuotas",
		firstDueDate: "Primer vencimiento",
		duplicateInterval: "Intervalo entre las cuotas",
		duplicatesDetails: "Detalles del parcelamiento",
		duplicateNumber: "Número de la cuota",
		dueDate: "Fecha de vencimiento",
		value: "Valor",
		intervalTypes: {
			Month: "Por mes",
			Week: "Por semana",
		},
		shippingValue: "Flete",
		insuranceValue: "Seguro",
		otherExpensesValue: "Gastos accesorios",
		icmsValue: "ICMS",
		icmsstValue: "ICMS ST",
		ipiValue: "IPI",
		associatedProduct: "Producto equivalente",
		associatedChartAccount: "Plan de cuentas",
		count: "Cantidad",
		unitCostValue: "Costo unitario",
		totalCost: "Costo total",
		basicStorageUnit: "Unidad de Medida",
		success: "Importación realizada con éxito",
		storage: "Inventario",
		accessKeyInfo:
			"La clave de acceso de la NF-e está compuesta por 44 dígitos numéricos que identifican la factura fiscal electrónica. Incluye información como el CNPJ del emisor, UF, año y mes de emisión, número de la factura, modelo, serie, y código de control único.",
	},
	sections: {
		inviceDetails: "Datos de la factura fiscal",
		duplicates: "Pago parcelado",
		expenses: "Flete y gastos",
		taxes: "Impuestos",
		products: "Productos",
	},
	validations: {
		storageIsRequired: "Es obligatorio seleccionar un inventario.",
		duplicateInvoice: "Esta factura ya fue importada.",
		supplierIsRequired: "Es obligatorio seleccionar un emisor.",
		numIsRequired: "Es obligatorio informar el número de la factura.",
		numIsInvalid: "Número de la factura debe contener solo números.",
		serieIsInvalid: "Serie debe contener solo números.",
		serieIsRequired: "Es obligatorio informar la serie de la factura.",
		operationTypeIsRequired: "Es obligatorio informar la naturaleza de la operación.",
		totalValueIsRequired: "Es obligatorio informar el valor total de la factura.",
		productsIsRequired: "Es obligatorio informar al menos un producto.",
		invalidAccessKey: "Clave de acceso inválida.",
	},
};
